import { render, staticRenderFns } from "./deliveryNote.vue?vue&type=template&id=a052671e"
import script from "./deliveryNote.vue?vue&type=script&lang=js"
export * from "./deliveryNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports